/* eslint-disable no-await-in-loop */
import { CloudWatchLogsClient, CreateLogStreamCommand, DescribeLogStreamsCommand, PutLogEventsCommand } from '@aws-sdk/client-cloudwatch-logs'

const cloudWatchLogsClient = new CloudWatchLogsClient({ region: 'eu-west-1', credentials: { accessKeyId: 'AKIARTQLPSQBWL2JCAWH', secretAccessKey: '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' } })

export const createCloudWatchSequenceToken = async (logGroupName: string, logStreamName: string): Promise<string | undefined> => {
  const describeLogStreamsCommand = new DescribeLogStreamsCommand({
    logGroupName,
    logStreamNamePrefix: logStreamName,
  })

  const describeLogStreamsResponse = await cloudWatchLogsClient.send(describeLogStreamsCommand)

  if (describeLogStreamsResponse.logStreams?.length) {
    return describeLogStreamsResponse.logStreams[0].uploadSequenceToken
  }

  const createLogStreamCommand = new CreateLogStreamCommand({
    logGroupName,
    logStreamName,
  })

  await cloudWatchLogsClient.send(createLogStreamCommand)

  // checking if the log stream was created, after 10s, we give up
  const timeoutMs = 10000
  const pollIntervalMs = 500
  let elapsedMs = 0
  while (elapsedMs < timeoutMs) {
    await new Promise((resolve) => {
      setTimeout(resolve, pollIntervalMs)
    })

    const describeCreatedLogStreamsCommand = new DescribeLogStreamsCommand({
      logGroupName,
      logStreamNamePrefix: logStreamName,
    })

    const describeCreatedLogStreamsResponse = await cloudWatchLogsClient.send(describeCreatedLogStreamsCommand)

    if (describeCreatedLogStreamsResponse.logStreams?.length) {
      return describeCreatedLogStreamsResponse.logStreams[0].uploadSequenceToken
    }

    elapsedMs += pollIntervalMs
  }

  throw new Error('Failed to create log stream')
}

export const putLogEvents = async (userType: string, userId: string, logEvents: any, action: string, successful: boolean, reason?: string) => {
  const logGroupName = 'PhoneLogs'
  const logStreamName = `${userType} | ${userId}`

  let sequenceToken

  try {
    sequenceToken = await createCloudWatchSequenceToken(logGroupName, logStreamName)
  } catch {
    console.log('Failed to create log stream')
    return
  }

  const putLogEventsCommand = new PutLogEventsCommand({
    logGroupName,
    logStreamName,
    logEvents: [
      {
        timestamp: Date.now(),
        message: JSON.stringify({
          successful,
          action,
          reason,
          entries: logEvents || [],
        }),
      },
    ],
    sequenceToken,
  })

  await cloudWatchLogsClient.send(putLogEventsCommand)
}
